import { render, staticRenderFns } from "./groupNode2.vue?vue&type=template&id=77172794&"
import script from "./groupNode2.vue?vue&type=script&lang=ts&"
export * from "./groupNode2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports